import { useEffect } from "react";
import { Card } from "antd";
import { NavLink } from "react-router-dom";
import {
  ExclamationCircleOutlined,
  TagsOutlined,
  CheckCircleOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons"; // Import des icônes
import styles from "./ParametragePage.module.scss";
import { useUserContext } from "../contexts/UserContext";
import Main from "../components/layouts/Main";
import Breadcrumb from "../components/utils/Breadcrumb";
import PageTitle from "../components/utils/PageTitle";
import ConfigurationDetails from "../components/configuration/ConfigurationDetails";

export default function ParametragePage() {
  const { check } = useUserContext();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll vers le haut de la page
  }, []);

  const items = [
   {
      title: "Priorités des dossiers et tâches",
      link: "/priorite",
      description:
        "Définissez et organisez les priorités pour vos dossiers et tâches, afin de mieux gérer les urgences et l'importance des éléments de votre projet.",
      icon: <ExclamationCircleOutlined className={styles.icon} />,
    },
    {
      title: "Statuts des tâches",
      link: "/statut",
      description:
        "Créez et gérez les statuts qui représentent l'état actuel des dossiers et tâches, comme 'En cours', 'Terminé' ou 'En attente', pour suivre efficacement leur avancement.",
      icon: <TagsOutlined className={styles.icon} />,
    },
    {
      title: "Modèles de dossiers",
      link: "/modele",
      description:
        "Gérez des modèles réutilisables pour standardiser la création de nouveaux dossiers ou tâches, en appliquant des configurations prédéfinies. Ces modèles seront associés à des étapes.",
      icon: <AppstoreAddOutlined className={styles.icon} />,
    },
    {
      title: "Étapes du processus",
      link: "/etape",
      description:
        "Configurez les étapes importantes de votre processus, permettant de structurer vos flux de travail en phases claires et organisées.",
      icon: <CheckCircleOutlined className={styles.icon} />,
    },
    {
      title: "Monnaies utilisées pour les dépenses",
      link: "/monnaie",
      description:
        "Définissez les monnaies utilisées dans votre application, la monnaie par défaut sera utilisée pour les montants.",
      icon: <AppstoreAddOutlined className={styles.icon} />,
    }
  ];

  return (
    <Main>
      <Breadcrumb
        parentLink="/"
        canSee={check("VIEW-DASHBOARD")}
        parentLinkTitle="Accueil"
        title="Paramétrage"
      />
      <PageTitle
        title="Paramétrage"
        subTitle="Gérez les priorités, statuts, étapes et modèles"
      />
      <div className={styles.listContainer}>
        <ConfigurationDetails />
        {items.filter(item => item).map((item, index) => (
          <NavLink to={item.link} key={index} className={styles.itemLink}>
            <Card hoverable className={styles.itemCard} classNames={{body: 'py-1'}}>
              <div className={styles.cardHeader}>
                {item.icon}
                <h3 className={styles.itemTitle}>{item.title}</h3>
              </div>
              <p className={styles.itemDescription}>{item.description}</p>
            </Card>
          </NavLink>
        ))}
      </div>
    </Main>
  );
}
